var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-container',[_vm._l((_vm.daysList),function(dayInfo,index){return [_c('table-cell',{key:("date-cell-" + index),class:_vm.getDailyColorClass(dayInfo)},[_c('daily-date-cell',{attrs:{"day-info":dayInfo}})],1)]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }